import type { AnyAction, ThunkAction } from '@reduxjs/toolkit';
import { configureStore as configureStoreToolkit } from '@reduxjs/toolkit';
import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { accountApiSlice } from '../../features/app/api/accounts/accountApiSlice';
import { contractApiSlice } from '../../features/app/api/contracts/contractApiSlice';
import { discountApiSlice } from '../../features/app/api/discount/discountApiSlice';
import { paymentMethodRequirementApiSlice } from '../../features/app/api/paymentMethodRequirements/paymentMethodRequirementApiSlice';
import { activationSummaryApiSlice } from '../../features/app/api/services/activationSummaryApiSlice';
import { rootReducer } from '../../reducers';

export const configureStore = () =>
    configureStoreToolkit({
        reducer: rootReducer,
        middleware: getDefaultMiddleware =>
            getDefaultMiddleware().concat(
                accountApiSlice.middleware,
                contractApiSlice.middleware,
                activationSummaryApiSlice.middleware,
                discountApiSlice.middleware,
                paymentMethodRequirementApiSlice.middleware
            ),
        enhancers: getDefaultEnhancers =>
            getDefaultEnhancers({
                autoBatch: import.meta.env.MODE === 'test' ? { type: 'timer', timeout: 0 } : { type: 'raf' },
            }),
    });

const store = configureStore();

export type RootState = ReturnType<typeof store.getState>;
export type RootDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, AnyAction>;

export const useAppDispatch: () => RootDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export { store };
